import { LeadActivityType } from "views/leads-id/types";

export const LEAD_ACTIVITY_TYPE_LABELS: Record<LeadActivityType, string> = {
  lead_created_by_user: "Lead created",
  lead_created_auto: "Lead created (auto)",
  lead_details_edited: "Details edited",
  file_uploaded: "File uploaded",
  file_deleted: "File deleted",
  note_added: "Note added",
  email_invite_sent: "Invited to apply",
  stage_changed_manual: "Stage changed",
  stage_changed_auto: "Stage changed",
  identity_verification_passed: "IDV passed",
  identity_verification_passed_with_warnings: "IDV passed with warnings",
  identity_verification_failed: "IDV failed",
  identity_verification_overridden: "IDV overridden",
  identity_verification_retry_requested: "IDV retry requested",
  identity_verification_retry_completed: "IDV retry completed",
  identity_verification_expired: "IDV expired",
  lead_assigned: "Lead assigned",
  identity_verification_data_edited: "IDV data edited",
  prescreening_submitted: "Prescreening submitted",
  prescreening_failed: "Prescreening failed",
  prescreening_completed: "Prescreening submitted",
  prescreening_abandoned: "Prescreening abandoned",
  identity_verification_not_finished: "Lead didn't finish the ID check",
  email_received: "Email received",
  email_sent: "Email sent",
  email_opened: "Email opened",
  sms_received: "SMS received",
  sms_sent: "SMS sent",
  sms_not_sent: "SMS not sent",
  sms_undeliverable_marked: "Can't receive texts",
  sms_reachability_restored: "Can receive texts again",
  manual_record: "Manual record",
  showing_invite_sent: "Showing invite sent",
  showing_requested: "Showing requested",
  showing_moved_to_pending: "Showing request moved to Pending",
  showing_scheduled: "Showing scheduled",
  showing_confirmed: "Showing confirmed",
  ai_call_received: "AI call received",
  ai_call_escalation_emailed: "Escalation emailed",
  ai_call_escalation_email_failed: "Escalation email not delivered",
  outbound_call_placed: "Outbound call placed",
  inbound_call_received: "Incoming call received",
  inbound_call_forwarded: "Incoming call forwarded",
  inbound_call_forward_failed: "Call forward unsuccessful",
  inbound_call_text_only: "Incoming call not forwarded",
  call_transferred: "Call transferred",
  call_transfer_not_answered: "Call transfer not answered",
  call_participant_added: "Person added to call",
  call_participant_not_answered: "Add to call not answered",
  showing_rescheduled: "Showing rescheduled",
  showing_checked_in: "Checked in to showing",
  showing_checked_out: "Checked out of showing",
  showing_feedback_submitted: "Showing feedback submitted",
  showing_lockbox_not_configured: "Check-in skipped: lockbox not configured",
  showing_cancelled: "Showing canceled",
  showing_reassigned: "Showing reassigned",
  showing_completed: "Showing completed",
  showing_no_show: "Showing no-show",
  showing_guided_confirmed: "Showing attendance confirmed",
  showing_confirm_after_cancel: "Tried to confirm after cancellation",
  showing_serial_number_incorrect: "Incorrect lockbox serial number",
  showing_serial_number_lockout: "Locked out of self-guided check-in",
  tenant_notified_of_showing: "Tenant notified of showing",
  push_lead_to_pms_success: "Pushed to PMS",
  push_lead_to_pms_failed: "PMS push failed",
  email_unsubscribed: "Unsubscribed from emails",
  email_resubscribed: "Re-subscribed to emails",
  campaign_email_sent: "Campaign email sent",
  campaign_sms_sent: "Campaign text sent",
  showing_not_checked_in: "Did not check in to self-guided showing",
  showing_lockbox_code_sent: "Lockbox code sent",
  showing_entry_instructions_sent: "Entry instructions sent",
  showing_entry_check_sent: "Asked if they got into the unit",
  showing_entry_confirmed: "Got into the unit",
  showing_entry_failed: "Couldn't get into the unit",
  showing_entry_no_reply: "No reply to entry check",
  new_inquiry: "New inquiry",
  tag_added: "Tag added",
  tag_removed: "Tag removed",
  ai_call_follow_up_needed: "Caller needs follow-up",
  lead_auto_assigned: "Lead assigned",
  lead_type_changed: "Lead type changed",
  prescreening_skipped: "Pre-screening skipped",
  showing_reschedule_request_sent: "Reschedule request sent",
  showing_reschedule_request_resent: "Reschedule request resent",
  showing_reschedule_request_replaced: "Reschedule request replaced",
  showing_reschedule_request_withdrawn: "Reschedule request withdrawn",
  showing_reschedule_request_closed: "Reschedule request closed",
  showing_reschedule_request_opened: "Reschedule link opened",
  showing_reschedule_request_expired: "Reschedule request expired",
  showing_rescheduled_by_lead: "Rescheduled by lead",
  showing_reschedule_other_times_requested: "Lead asked for other times",
  showing_reschedule_requested_by_lead: "Reschedule requested by lead",
  showing_cancelled_from_reschedule_page: "Canceled from reschedule page",
  showing_reschedule_reminder_sent: "Reschedule reminder sent"
};
